<template>
  <div>
    <LoadingContainer v-if="loading"/>

    <div v-else>
      <FormPanel
          :initial="contentRegistrationCategory.attributes"
          headline="Edit Registration Category"
          :errors="errors"
          @submit="submit"
      />
    </div>
  </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import FormPanel from '../../../../../../../components/Administration/ContentRegistrationCategories/Panels/Form'
import LoadingContainer from '../../../../../../../components/Layout/LoadingContainer'

export default {
  components: {LoadingContainer, FormPanel},

  props: {
    portal: {
      required: true
    },

    blockDrivers: {
      required: true
    },

    layoutCategories: {
      required: true
    }
  },

  data() {
    return {
      contentRegistrationCategory: null,
      loading: true,

      errors: {}
    }
  },

  mounted() {
    this.load()
  },

  methods: {
    load() {
      http.get('/api/v2/content-registration-categories/' + this.$route.params.contentRegistrationCategoryId).then(response => {
        this.contentRegistrationCategory = response.data.data

        this.loading = false
      })
    },

    submit(data) {
      http.put('/api/v2/content-registration-categories/' + this.$route.params.contentRegistrationCategoryId, data)
          .then(response => {
            notify.success('The content registration category was saved')

            this.contentRegistrationCategory = response.data.data

            this.errors = {}
          })
          .catch(error => {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors
            }

            throw error
          })
    },
  }
}
</script>
